define('lq/services/mpa/serviceFactory',[
    'lq/typesProvider',

    './pasteCommand',
    './applicationValidation',
    './issueTracking'
], function (TypesProvider) {
    'use strict';

    var servicesTypes = Array.prototype.slice.call(arguments, 1);
    var typesProvider = new TypesProvider(servicesTypes);

    var createService = function(service, rootDrop) {
        var ServiceType = typesProvider.get(service.serviceType);
        var instance = new ServiceType(service.data);
        instance.rootDrop = rootDrop;
        instance.piping = rootDrop.piping;
        return instance;
    };

    return {
        createService: createService
    };
});
